import { render, staticRenderFns } from "./面试题17.24_最大子矩阵.md?vue&type=template&id=36dd1b9c&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports